import { Controller } from 'react-hook-form';
import { IonDatetime, IonDatetimeButton, IonIcon, IonItem, IonLabel, IonModal, IonRow, IonSkeletonText, IonText } from '@ionic/react';
import { WrapperDiv } from './FormDatePickerButton.styles';
import { useAppSelector } from '../../../store/hooks';
import { useRef, useState } from 'react';

interface IComponentProps {
  control: any;
  datetimeId: string;
  inputProps?: any;
  label?: string;
  name: string;
  placeholder: string;
  icon?: string;
  isLoading?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
  handleChange?: (value: string | null | undefined) => void;
  handleModalOpen?: (value: boolean) => void;
}

const FormDatePickerButton: React.FC<IComponentProps> = ({ control, datetimeId, inputProps, label, name, placeholder, icon, isLoading, disabled, min, max, handleChange, handleModalOpen }) => {
  const { isDarkMode } = useAppSelector(state => state.settings);
  const [selectedValue, setSelectdValue] = useState<string | undefined | null>('');
  const prevVal = useRef('');

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const onChangeHandler = (e: CustomEvent) => {
          onChange(e.detail.value!);
          handleChange && handleChange(e.detail.value!);
          setSelectdValue(e.detail.value!);
        };

        // A small tweak to get the defaultValue working. Ensure the value or defaultValue is never empty string
        setSelectdValue(value || undefined);
        if (value === '' && prevVal.current) {
          onChangeHandler({ detail: { value: prevVal.current } } as CustomEvent);
        }
        prevVal.current = value;

        return <WrapperDiv>
          <IonRow className="form-row flexed col">
            {isLoading ?
              <IonItem className="ion-no-padding flexed-fill">
                <IonLabel position="stacked">{label}</IonLabel>
                <IonSkeletonText animated />
                {icon && <IonIcon icon={icon} slot="end" size="small" />}
              </IonItem>
              :
              <div className="flexed-fill">
                <IonItem className="ion-no-padding flexed-fill" id={`open-date-input-${name}`}>
                  <div>
                    <IonLabel className="label-stacked">{label}</IonLabel>
                    <div>
                      <IonDatetimeButton slot="date-target" className={`date-time-button ${isDarkMode ? 'dark' : 'light'}`} datetime={datetimeId}>
                        {!selectedValue &&
                          <>
                            <div slot="date-target" className="select-date-label">
                              Select a Date
                            </div>
                            <div slot="time-target" className="select-time-label">
                              --
                            </div>
                          </>
                        }
                      </IonDatetimeButton>
                      <IonModal keepContentsMounted onIonModalWillPresent={() => handleModalOpen && handleModalOpen(true)} onIonModalWillDismiss={() => handleModalOpen && handleModalOpen(false)}>
                        <IonDatetime id={datetimeId} {...inputProps} placeholder={placeholder} showDefaultButtons onIonChange={e => onChangeHandler(e)} value={value || undefined} disabled={disabled} min={min} max={max} color="calendar" />
                      </IonModal>
                    </div>
                  </div>

                  {icon && <IonIcon icon={icon} slot="end" size="small" />}
                </IonItem>
                {error && <IonText className="error">{error.message}</IonText>}
              </div>
            }
          </IonRow>
        </WrapperDiv>;
      }}
    />
  );
};

export default FormDatePickerButton;
